import { z } from 'zod';
export const MUSIC_GENRES = [
    'Electronic',
    'Hip-Hop/Rap',
    'Pop',
    'Rock',
    'Jazz',
    'Ambient',
    'Classical',
    'R&B/Soul',
    'House',
    'Techno',
    'Drum & Bass',
    'Lo-Fi',
    'Alternative',
    'Acoustic',
    'World'
];
export const musicMoodSchema = z.enum(['personal', 'calm', 'energy', 'focus']);
export const musicIdSchema = z.string().regex(/^(?:[a-zA-Z0-9]{3,32}|ia_[a-f0-9]{32})$/);
export const musicPreferencesSchema = z
    .object({ genres: z.array(z.enum(MUSIC_GENRES)).max(8), mood: musicMoodSchema })
    .strict();
export const musicQuerySchema = z.object({
    q: z.string().trim().max(160).default(''),
    genre: z.enum(MUSIC_GENRES).optional(),
    offset: z.coerce.number().int().min(0).max(10000).default(0),
    limit: z.coerce.number().int().min(1).max(50).default(24)
});
export const musicPlaylistSchema = z.object({ title: z.string().trim().min(1).max(80) }).strict();
export const musicPlaylistUpdateSchema = z
    .object({
    title: z.string().trim().min(1).max(80),
    trackIds: z
        .array(musicIdSchema)
        .max(200)
        .refine((ids) => new Set(ids).size === ids.length),
    revision: z.number().int().min(0)
})
    .strict();
//# sourceMappingURL=music.js.map